import React from 'react';
import { useTranslation } from 'react-i18next';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import pvpImg from '../../assets/img/pvp.png';
import namelockVid from '../../assets/vid/Namelock.mp4';
import namelockStompVid from '../../assets/vid/Namelock_Stomp.mp4';
import namelockChainsVid from '../../assets/vid/Namelock_to_Teleport_Chains.mp4';
import throwlockVid from '../../assets/vid/Throwlock_locking_with_Blessed_Hammer_on_left_side.mp4';
import ctVid from '../../assets/vid/ct_teleport.mp4';
import smiteVid from '../../assets/vid/Smite_Cast_Combo.mp4';
import telelocksVid from '../../assets/vid/Telelocks.mp4';
import fohVid from '../../assets/vid/FoH_Combo.mp4';
import d2a from '../../assets/img/d2a.png';
import d2g from '../../assets/img/d2g_logo.png';
import NavPills from 'components/NavPills/NavPills.js';
import { primaryColor } from '../../assets/jss/material-kit-react';

export default function GuidesContent() {
  const { t } = useTranslation();

  const tourDiscords = [
    {
      name: 'd2g',
      image: d2g,
      discord_invite: 'https://discord.gg/xwtATmyEkN',
      tours: [
        {
          name: 'Necro vs Druid (NvD/DvN)',
          ruleset: 'standard',
          time: '18 cet',
          day: 'Wednsday or Thursday',
          participants: '',
          participants_current: '8',
          participants_max: '16',
          prize: '???',
        },
        {
          name: '1v1 D²G Diggi tour',
          ruleset: 'standard',
          time: '18 cet',
          day: 'Friday',
          participants: '',
          participants_current: '8',
          participants_max: '16',
          prize: '???',
        },
        {
          name: 'Team vs Team',
          ruleset: 'tvt',
          time: '18 cet',
          day: 'Saturday',
          participants: '',
          participants_current: '8',
          participants_max: '16',
          prize: '???',
        },
      ],
      streams: ['jayroxor'],
      ruleSets: [
        {
          name: 'standard',
          content: (
            <span
              style={{
                display: 'block',
                padding: '20px',
                backgroundColor: '#f0f0f0',
                border: '1px solid #ccc',
                borderRadius: '5px',
              }}
            >
              <div className="container">
                <h2 style={{ color: primaryColor }}>
                  {t('tournaments.signup.title', 'Signing up as Tour Participant')}
                </h2>
                <p>
                  <a
                    href="https://discord.gg/xwtATmyEkN"
                    style={{ color: primaryColor, textDecoration: 'none' }}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <button
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '10px 20px',
                        border: 'none',
                        backgroundColor: primaryColor,
                        color: 'white',
                        fontSize: '16px',
                        width: '100%',
                        borderRadius: '5px',
                        cursor: 'pointer',
                      }}
                    >
                      Join the D2G Discord to participate!
                    </button>
                  </a>
                </p>
                <p>Participants must be a member of the D²G discord server.</p>
                <p>
                  Once the tour registration is closed, the character class you have signed up with
                  is fixed and final. Also, if you are playing a class that has multiple builds,
                  please PM your build variant to one of the admins/mods available and online before
                  the brackets are rolled. We will also announce the closing of the sign-up and the
                  time to post your builds before rolling the bracket!
                </p>
                <p>
                  Do NOT deafen yourself in the voice channel (you can deafen other people than mods
                  of course if you feel disturbed - a tour mod has to reach you via voice! If they
                  cannot, your duel will result in a round or even duel loss).
                </p>
                <p>
                  You cannot participate in tournaments if you blocked or muted a member of the
                  tour-crew.
                </p>

                <div className="rules-list">
                  <h3>Start & Ending of a Duel</h3>
                  <ul>
                    <li>
                      Players/teams must be set hostile. The player joining the game last is
                      responsible for setting the opposing player(s) hostile. Rounds where one or
                      more players are not set hostile will be redone. If this happens multiple
                      times the responsible player/team will receive a round loss on consequent
                      rounds
                    </li>
                    <li>
                      Both players signal their readiness by posting {"'"}g{"'"} or {"'"}go{"'"} in
                      the chat. It only stands for 5 seconds and has to be signaled again after that
                      period. No offensive abilities or curses should be casted prior to the start
                      of the duel
                    </li>
                    <li>
                      The duel can be interrupted by typing {"'"}s{"'"} or {"'"}sec{"'"} (To call a
                      Mediator)
                    </li>
                    <li>
                      Picking Mana is not a reason to interrupt a duel. The round has not to be
                      paused when a player calls {"'"}m{"'"} or {"'"}mana{"'"} unless all mana pools
                      are depleted. The duel will continue once the mana pool has been replenished
                      by a helper and both players signal their readiness by posting {"'"}g{"'"} or{' '}
                      {"'"}go{"'"} in the chat
                    </li>
                    <li>You are not allowed to use any skill/ability while waiting for mana!</li>
                    <li>
                      Excessive Use of Interruption-Calls will result in a loss round and may also
                      end in a disqualification
                    </li>
                    <li>
                      Chatting within an active round is not allowed. (Except causing an
                      interruption, see above) There will be a one-time warning followed by round
                      loss or even a DQ
                    </li>
                    <li>Ties are null duels</li>
                    <li>
                      A disconnection will count as a loss unless both players agree to redo the
                      round
                    </li>
                  </ul>

                  <h3>Area/Map</h3>
                  <ul>
                    <li>
                      Blood Moor, Bridge Map, fully cleared. Square without Boxes preferred (H
                      Pattern)
                    </li>
                    <li>Item spacing must be turned off when creating games</li>
                  </ul>

                  <h3>Map Objective Restriction</h3>
                  <ul>
                    <li>
                      Excessive Camping around/in houses/boxes or entering the Den will result in
                      actions against the abusive player
                    </li>
                    <li>
                      Taking shrines is forbidden. If a shrine causing an advantage for the player
                      is taken either consciously or accidentally, the round will count as a loss
                      (Removing a curse is considered an advantage. Any shrine except XP, mana
                      regen, and stamina shrine is considered advantageous)
                    </li>
                  </ul>

                  <h3>Mana Pooling</h3>
                  <ul>
                    <li>Mana may be pooled all over the map</li>
                    <li>You cannot purposefully camp mana or drink mana to deplete the pool</li>
                  </ul>

                  <h3>Showcasing & Character Name</h3>
                  <ul>
                    <li>Make sure to show your life tooltip numbers above the life bubble</li>
                    <li>
                      Every player or team has the right to request the showcase of a player{"'"}s
                      current setup and stats. Opening the stash will result in a loss of all
                      previous rounds; a refusal will result in a disqualification
                    </li>
                    <li>
                      Using a build or itemization against the Ruleset will also result in a
                      disqualification
                    </li>
                    <li>Character names must not be shorter than 2 Latin letters</li>
                  </ul>

                  <h3>D2R/Blizzard Terms of Service</h3>
                  <ul>
                    <li>
                      Any violation against the Game{"'"}s Terms of Service will result in a
                      disqualification
                    </li>
                  </ul>

                  <h3>Precast</h3>
                  <ul>
                    <li>Only from Cube (inventory) is allowed</li>
                  </ul>

                  <h3>Allowed Classes & Builds / Token Usage</h3>
                  <ul>
                    <li>
                      You may enter the tournament with one of the following Builds/Class: Wind
                      Druid, Assassin, Barb, Necro, Paladin (Smiter variants or Hammerdin),
                      Sorceress, Javazon & Bowazon
                    </li>
                    <li>
                      Using Respec-Tokens is not allowed during an active tournament or duel unless
                      specifically stated
                    </li>
                  </ul>

                  <h3>Gameplay & Behavior / Priding</h3>
                  <ul>
                    <li>
                      Toxic attitude and arguing with the host/moderator or ignoring them will lead
                      to disqualification or even a ban
                    </li>
                    <li>
                      Excessive off-screening is prohibited. This includes random ability spamming
                      (Builds with access to Teleport Skill)
                    </li>
                    <li>
                      Defensive gameplay is accepted to an extent; refusal to attack an opponent is
                      not. {"'"}Catch me if you can{"'"} playstyle will result in a round loss
                    </li>
                    <li>
                      Avoiding contact with an opponent intentionally with no plans of direct
                      attacking is considered priding and will result in a round loss
                    </li>
                    <li>
                      If you get to a low life, continue dueling to the finish. Running to replenish
                      life will lead to Loss/DQ
                    </li>
                    <li>
                      No camping in houses, near walls, corners, puddles, or any other map
                      objectives
                    </li>
                    <li>
                      Share your screen on the D²G discord server before your match has started, no
                      exceptions or excuses! If you cannot screen share without issues, do NOT join
                      the tournament! If you break this rule: warning -{'>'} round loss -{'>'} DQ
                    </li>
                    <li>Stream sniping is prohibited</li>
                    <li>
                      Switch Casting as shown in Cooley{"'"}s YT video is prohibited to use and will
                      lead to an instant DQ
                    </li>
                  </ul>

                  <h3>Ingame Video Resolution</h3>
                  <ul>
                    <li>
                      You are not allowed to use any resolution with an aspect ratio higher than
                      16:9. Breaking this rule will lead to disqualification!
                    </li>
                  </ul>

                  <h3>Item Bans & Restrictions</h3>
                  <ul>
                    <li>
                      <strong>Runewords</strong>
                      <ul>
                        <li>Plague, Lawbringer</li>
                        <li>Any runeword granting a Damage dealing aura</li>
                        <li>Phoenix Runeword (Shield) is globally banned against Fire-Sorceress</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Magical / Rare / Uniques</strong>
                      <ul>
                        <li>
                          Rising Sun, Blackoak Luna, The Reaper{"'"}s Toll, Executioner{"'"}s
                          Justice are banned
                        </li>
                        <li>Sunder Grand Charms are banned</li>
                        <li>
                          You may wear one item that grants {"'"}Chance to cast{"'"} Lifetap
                        </li>
                        <li>
                          You are allowed to use one Poison and one of each Elemental damage type
                          Small Charm at the same time
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Consumable Items</strong>
                      <ul>
                        <li>
                          No other than Mana Potions, Bolts, Arrows are allowed; this includes the
                          use of Throwing Potions
                        </li>
                        <li>
                          Rejuv & Healing Potions may only be used against Poison Damage (necro &
                          poison bow amazon)
                        </li>
                        <li>Gas Potions are prohibited</li>
                        <li>Antidote, Stamina & Thawing Potions are prohibited</li>
                      </ul>
                    </li>
                  </ul>
                  <h3>Abilities & Spells / Skill Restrictions</h3>
                  <ul>
                    <li>
                      Globally Banned Skills: Mind Blast, Bone Prison, Holy Freeze, Decrepify, and
                      Attract
                    </li>
                    <li>
                      <strong>Assassin</strong>
                      <ul>
                        <li>No restrictions</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Barbarian</strong>
                      <ul>
                        <li>Leap is banned</li>
                        <li>Banned against Warcry: Doom runeword, Last Wish runeword</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Necromancer</strong>
                      <ul>
                        <li>
                          Bone Spirit has to be casted within 1.5 screens of the opponent and Bone
                          Wall is not allowed to be casted directly on an opponent, casted walls
                          must have a 1 screen distance from an opponent
                        </li>
                        <li>
                          Poison Nova & Bone Spirit/Teeth hybrid builds are not allowed. One or the
                          other skill set has to be dominant with maxed synergies
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Druid</strong>
                      <ul>
                        <li>
                          Recasting Cyclone armor more than once per 10 seconds is not allowed
                        </li>
                        <li>Twister and Tornado hybrids are not allowed</li>
                        <li>Life Replenish from gear is limited to 20</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Paladin</strong>
                      <ul>
                        <li>Auradin is banned</li>
                        <li>
                          Smite has a life tap of one cast per duel. Life tab may not be recast once
                          overwritten
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Amazon</strong>
                      <ul>
                        <li>Banned Skills: Decoy</li>
                        <li>
                          Poison Javelin Skill Tree Hybrids are not allowed, the build must be
                          focused on either Poison or Lightning
                        </li>
                        <li>Valkyrie is banned in Bow vs. Bow duels</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Sorceress</strong>
                      <ul>
                        <li>Energy Shield</li>
                        <li>ES has to be maxed as well as its synergy Telekinesis</li>
                        <li>
                          ES has to be active the entire duel and must not be turned off to pre-buff
                          other spells
                        </li>
                        <li>
                          Single Skill focused builds are not allowed. You must use a combination of
                          at least 2 Skills
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </span>
          ),
        },
      ],
      guides: [
        {
          name: 'General PvP Guide',
          nameImage: pvpImg,
          ruleset: 'all',
          date: '',
          className: 'all',
          difficulty: '',
          sections: [
            {
              name: 'Namelock',
              content: (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    textAlign: 'center',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      textAlign: 'center',
                    }}
                  >
                    <p>Namelock</p>
                    <ul style={{ listStyleType: 'circle', textAlign: 'left' }}>
                      <li>Place cursor over your opposition</li>
                      <li>Click attack with your mouse and hold it down</li>
                      <li>
                        It is best practice to get used to centering your cursor after grabbing your
                        lock!
                      </li>
                    </ul>
                  </div>
                  {/* eslint-disable-next-line react/no-unknown-property */}
                  <video style={{ maxWidth: '100%' }} controls>
                    <source src={namelockVid} type="video/mp4" />
                    <track kind="captions" src="" label="English" default />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ),
            },
            {
              name: 'Namelock Stomp',
              content: (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    textAlign: 'center',
                  }}
                >
                  <p>Namelock Stomp</p>
                  <ul style={{ listStyleType: 'circle', textAlign: 'left' }}>
                    <li>Place cursor over your opposition</li>
                    <li>Click attack with your mouse and hold it down</li>
                    <li>
                      It is best practice to get used to centering your cursor after grabbing your
                      lock!
                    </li>
                    <li>Change to Teleport whilst holding your lock</li>
                  </ul>
                  {/* eslint-disable-next-line react/no-unknown-property */}
                  <video style={{ maxWidth: '100%' }} controls>
                    <source src={namelockStompVid} type="video/mp4" />
                    <track kind="captions" src="" label="English" default />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ),
            },
            {
              name: 'Namelock to Teleport Chains',
              content: (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    textAlign: 'center',
                  }}
                >
                  <p>Namelock to Teleport Chains</p>
                  <ul style={{ listStyleType: 'circle', textAlign: 'left' }}>
                    <li>Place cursor over your opposition</li>
                    <li>Click attack with your mouse and hold it down</li>
                    <li>
                      It is best practice to get used to centering your cursor after grabbing your
                      lock!
                    </li>
                    <li>Change to Teleport whilst holding your lock</li>
                    <li>
                      Continue to hold down Teleport with your cursor in the centre of the screen
                      (preferably at your character{"'"}s feet)
                    </li>
                    <li>Beginners: Hold down Teleport with your cursor in the centre</li>
                    <li>
                      Pro: Re-click on each Teleport to keep your lock consistently, allowing more
                      control overall
                    </li>
                  </ul>
                  {/* eslint-disable-next-line react/no-unknown-property */}
                  <video style={{ maxWidth: '100%' }} controls>
                    <source src={namelockChainsVid} type="video/mp4" />
                    <track kind="captions" src="" label="English" default />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ),
            },
            {
              name: 'Throwlock',
              content: (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    textAlign: 'center',
                  }}
                >
                  <p>Throwlock</p>
                  <p>
                    It is worth noting that not all skills, such as Blessed Hammer, allow you to
                    switch to Teleport in order to stomp your opposition. A good alternative is to
                    switch to Throw, allowing you to Teleport onto your victim accordingly. Locking
                    players with Throw is a common habit, cutting out animation time that would
                    occur with other skills requiring full casting.
                  </p>
                  <p>
                    This is also a good time to get used to switching from skills on the left side
                    to the right when attacking.
                  </p>
                  <ul style={{ listStyleType: 'circle', textAlign: 'left' }}>
                    <li>Place cursor over your opposition</li>
                    <li>Click left attack with your mouse and hold it down</li>
                    <li>
                      It is best practice to get used to centering your cursor after grabbing your
                      lock!
                    </li>
                    <li>
                      Change to Throw while your hammer is casting and you are holding your lock
                    </li>
                    <li>Change to Teleport while holding your lock</li>
                    <li>Make your next move (chains/attacks are always a good idea!)</li>
                  </ul>
                  {/* eslint-disable-next-line react/no-unknown-property */}
                  <video style={{ maxWidth: '100%' }} controls>
                    <source src={throwlockVid} type="video/mp4" />
                    <track kind="captions" src="" label="English" default />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ),
            },
            {
              name: 'Telelocks',
              content: (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    textAlign: 'center',
                  }}
                >
                  <p>Telelocks</p>
                  <ul style={{ listStyleType: 'circle', textAlign: 'left' }}>
                    <li>Place cursor over your opposition whilst having teleport ready to use</li>
                    <li>Click attack with your mouse to action the teleport</li>
                    <li>Center your mouse to your feet before the Teleport lands</li>
                    <li>This allows you to take action once the stomp has finished</li>
                    <li>Make your next move (chains/attacks are always a good idea!)</li>
                  </ul>
                  {/* eslint-disable-next-line react/no-unknown-property */}
                  <video style={{ maxWidth: '100%' }} controls>
                    <source src={telelocksVid} type="video/mp4" />
                    <track kind="captions" src="" label="English" default />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ),
            },
            {
              name: 'C/T Teleport',
              content: (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    textAlign: 'center',
                  }}
                >
                  <p>C/T Teleport</p>
                  <p>
                    The C/T teleport method allows for greater teleportation distances than usual.
                    Advantages include quicker off-screen escapes, rapid pursuit of targets, and the
                    ability to stomp stationary players who cannot see you on their screen.
                  </p>
                  <p>
                    Adjusting your screen borders via calibration can provide better visibility of
                    your target before teleporting. Alternatively, you can use the map to line up
                    your teleports once you are familiar with the required distance.
                  </p>
                  <ul style={{ listStyleType: 'circle', textAlign: 'left' }}>
                    <li>
                      Open the character screen to teleport left or the skill screen to teleport
                      right.
                    </li>
                    <li>
                      Move your cursor as far to the edge as possible (or over your target if they
                      are visible at the border).
                    </li>
                    <li>Teleport! (Note: deadspace can occur, preventing teleportation).</li>
                  </ul>
                  {/* eslint-disable-next-line react/no-unknown-property */}
                  <video style={{ maxWidth: '100%' }} controls>
                    <source src={ctVid} type="video/mp4" />
                    <track kind="captions" src="" label="English" default />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ),
            },
            {
              name: 'Smite Combo',
              content: (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    textAlign: 'center',
                  }}
                >
                  <p>Smite Combo</p>
                  <p>
                    Like chainlocking for left-click attackers, utilizing the Smite Combo is an
                    effective way of controlling the duel by maintaining high pressure and
                    increasing your chances of damaging your opponent. For Smiters, this maneuver
                    integrates the swirl effect with Smite, paving the way for a FoH combo.
                  </p>
                  <p>
                    Always ensure to keep your mouse centered, allowing you to re-lock/cast with
                    your cursor maintaining your opposition{"'"}s character in sight.
                  </p>
                  <ul style={{ listStyleType: 'circle', textAlign: 'left' }}>
                    <li>
                      Lock your opponent with left click (Smite, for example) - Lock/Telestomp to
                      mouse center are effective methods of initiating Smite Combo
                    </li>
                    <li>
                      While the Smite animation is in motion, activate Teleport on the Right
                      Skill-Set
                    </li>
                    <li>Right-click to cast Teleport</li>
                    <li>Smite {'>'} Repeat.</li>
                  </ul>
                  {/* eslint-disable-next-line react/no-unknown-property */}
                  <video style={{ maxWidth: '100%' }} controls>
                    <source src={smiteVid} type="video/mp4" />
                    <track kind="captions" src="" label="English" default />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ),
            },
            {
              name: 'FoH Combo',
              content: (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    textAlign: 'center',
                  }}
                >
                  <p>FoH Combo</p>
                  <p>
                    Once a Smiter has applied their swirl effect upon smiting their opposition, they
                    can proceed to use Fist of Heavens (FoH) to interrupt their casting.
                    Implementing this combo allows consistent damage application while maintaining
                    control of the duel.
                  </p>
                  <p>
                    FoH can be casted from either the left or right skill-set, altering the order in
                    which you click your mouse accordingly.
                  </p>
                  <ul style={{ listStyleType: 'circle', textAlign: 'left' }}>
                    <li>Lock your opposition with Smite, casting the attack</li>
                    <li>
                      Cast Fist of Heavens on your opposition (always keeping your mouse center)
                    </li>
                    <li>This will interrupt your opposition{"'"}s casting</li>
                    <li>If you FoH on the left, you do not need to reclick on your opposition</li>
                    <li>
                      If you FoH on the right, you will need to reclick after your Smite, using your
                      right skill cast attack
                    </li>
                    <li>Hold the lock when casting FoH</li>
                    <li>Using an aura like Holy Freeze or Conviction is optional</li>
                    <li>Cast Teleport while holding FoH lock to stomp your opposition</li>
                    <li>Repeat starting from Smite</li>
                  </ul>
                  {/* eslint-disable-next-line react/no-unknown-property */}
                  <video style={{ maxWidth: '100%' }} controls>
                    <source src={fohVid} type="video/mp4" />
                    <track kind="captions" src="" label="English" default />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ),
            },
          ],
        },
      ],
    },
    {
      tabName: 'd2a',
      name: 'd2a',
      image: d2a,
      discord_invite: 'https://discord.gg/R6vg2DbdhZ',
      tours: [
        {
          name: 'Mid Level Duel tour',
          ruleset: 'mld',
          time: '18 cet',
          day: 'Monday',
          participants: '',
          participants_current: '8',
          participants_max: '16',
          prize: '???',
        },
        {
          name: '1v1 D2A tour',
          ruleset: 'standard',
          time: '18 cet',
          day: 'Tuesday',
          participants: '',
          participants_current: '8',
          participants_max: '16',
          prize: '???',
        },
        {
          name: 'Clan Wars',
          ruleset: 'tvt',
          time: '18 cet',
          day: 'Sunday',
          participants: '',
          participants_current: '8',
          participants_max: '16',
          prize: '???',
        },
      ],
      streams: ['d2_arena', 'ak_fen0', 'h4r9'],
      ruleSets: [
        {
          name: 'standard',
          content: (
            <span
              style={{
                display: 'block',
                padding: '20px',
                backgroundColor: '#f0f0f0',
                border: '1px solid #ccc',
                borderRadius: '5px',
              }}
            >
              <h2 style={{ color: primaryColor, marginTop: '0' }}>General Rules</h2>
              <ul style={{ marginTop: '0', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '10px' }}>
                  All mods, hacks, programs are banned. (WMC and other mouse-window capture programs
                  are allowed.)
                </li>
                <li style={{ marginBottom: '10px' }}>
                  Toxic attitude and arguing with the host/moderator may lead to
                  loss/disqualification.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  Refusal to show gear, inventory, and/or weapon swap will result in suspension.
                </li>
                <li style={{ marginBottom: '10px' }}>The Moor is to be cleared before dueling.</li>
                <li style={{ marginBottom: '10px' }}>
                  Both players must signal the start of the duel.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  No offensive abilities or curses can be casted prior to your opponent signaling
                  the start of the duel.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  Towning or teleporting past Flavie and bridges may result in a loss, unless it
                  {"'"}s done non-deliberately.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  No use of houses (accidentally entering the house is excused).
                </li>
                <li style={{ marginBottom: '10px' }}>
                  No use of shrines or wells - Bridge maps should be used.
                </li>
                <li style={{ marginBottom: '10px' }}>Recasting is allowed.</li>
                <li style={{ marginBottom: '10px' }}>Ties are null duels.</li>
                <li style={{ marginBottom: '10px' }}>Refusal to duel results in a loss.</li>
                <li style={{ marginBottom: '10px' }}>
                  Overly defensive play will result in disqualification.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  Players may not leave battle orders down or drop gear to rep life faster.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  If you get to very low life (& mana for ES sorc), continue dueling to the finish.
                  Running to replenish may lead to Loss/DQ.
                </li>
                <li style={{ marginBottom: '10px' }}>Stream sniping is prohibited.</li>
                <li style={{ marginBottom: '10px' }}>
                  If you have been disconnected, you may only enter the battlefield again if
                  opponents agree to let you do so.
                </li>
                <li style={{ marginBottom: '10px' }}>Win trading is prohibited.</li>
                <li style={{ marginBottom: '10px' }}>
                  If you or your team forfeits, the player/team from the past round advances to the
                  next stage.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  Having resolution higher than 16:9 is not allowed.
                </li>
              </ul>

              <h2 style={{ color: primaryColor }}>Items</h2>
              <ul style={{ marginTop: '0', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '10px' }}>
                  No item charges are allowed with the exception of Oak Sage, Ravens, Enchant,
                  Teleport, and Heart of Wolverine.
                </li>
                <li style={{ marginBottom: '10px' }}>Slow is capped at 10%.</li>
                <li style={{ marginBottom: '10px' }}>
                  Max resistance is 85% (Exceptions are listed under class allowances).
                </li>
                <li style={{ marginBottom: '10px' }}>
                  No more than 450 total cold resistance (Bonus displayed on character screen) or
                  420 total cold resistance with Raven Frost.
                </li>
                <li style={{ marginBottom: '10px' }}>Max absorb is 20%.</li>
                <li style={{ marginBottom: '10px' }}>
                  Cannot use flat absorb in combination with % absorb to the same element.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  When using absorb (% or flat), do not exceed 80% max resistance to the same
                  element (exception for TGods/Phoenix).
                </li>
                <li style={{ marginBottom: '10px' }}>
                  No more than one poison damage small charm is allowed.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  Life rep is capped at 33, NOT including + rep from CTA.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  Only one item that grants CtC Life Tap can be worn at a time.
                </li>
              </ul>
            </span>
          ),
        },
      ],
      guides: [],
    },
  ];

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <NavPills
          queryKey={'org'}
          alignCenter
          color="primary"
          onChange={() => {}}
          tabs={[
            ...tourDiscords
              .filter((obj) => obj.guides.length > 0)
              .map((obj, index) => ({
                tabName: obj.name,
                tabButton: (
                  <span style={{ display: 'block' }} key={index}>
                    <img style={{ width: '64px' }} src={obj.image} alt={obj.name} />
                  </span>
                ),
                tabContent: (
                  <span
                    key={obj.name}
                    style={{
                      display: 'block',
                      width: '100%',
                      boxSizing: 'border-box',
                    }}
                  >
                    <NavPills
                      queryKey={'class'}
                      alignCenter
                      color="primary"
                      onChange={() => {}}
                      tabs={obj.guides
                        .filter((obj) => obj.sections.length > 0)
                        .map((sObj, index2) => ({
                          tabName: sObj.name,
                          tabButton: (
                            <span style={{ display: 'block' }} key={index2}>
                              {sObj.nameImage ? (
                                <>
                                  <img
                                    style={{ height: '64px' }}
                                    src={sObj.nameImage}
                                    alt={sObj.name}
                                  />
                                </>
                              ) : (
                                sObj.name
                              )}
                            </span>
                          ),
                          tabContent: (
                            <span key={index2}>
                              <NavPills
                                queryKey={'guide'}
                                alignCenter
                                color="primary"
                                onChange={() => {}}
                                tabs={sObj.sections.map((gSection: any, index3: number) => ({
                                  tabName: gSection.name,
                                  tabButton: (
                                    <span style={{ display: 'block' }} key={index3}>
                                      {gSection.nameImage ? (
                                        <>
                                          <img
                                            style={{ height: '64px' }}
                                            src={gSection.nameImage}
                                            alt={gSection.name}
                                          />
                                        </>
                                      ) : (
                                        gSection.name
                                      )}
                                    </span>
                                  ),
                                  tabContent: <span key={index3}>{gSection.content}</span>,
                                }))}
                              />
                            </span>
                          ),
                        }))}
                    />
                  </span>
                ),
              })),
          ]}
        ></NavPills>
      </GridItem>
    </GridContainer>
  );
}
